/*
=================================
THIRD PARTY URLS
=================================
*/

/**
 * Fetch countries url
 *
 * @returns url string
 *
 */

export const fetchCountriesURL = () =>
  `https://restcountries.com/v3.1/all?fields=name,postalCode`;
